import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import setAuthToken from "../utils/setAuthToken";
import { jwtDecode } from "jwt-decode";
import axios from "../utils/axiosInterceptor";

const isEmpty = require("is-empty");

// initial state
const initialState = {
  isAuthenticated: false,
  user: {},
  loading: false, 
  errors: {}
}

// Register User Thunk
export const registerUser = createAsyncThunk(
  'user/registerUser',
  async (userData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/api/users/register", userData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data)
    }
  }
)

// Login - get user token Thunk
export const loginUser = createAsyncThunk(
  'user/loginUser',
  async (userData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/api/users/login", userData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data)
    }
  }
)

// Log user out
export const logoutUser = () => dispatch => {
  localStorage.removeItem("jwtToken"); // Remove token from local storage
  localStorage.removeItem("colorMode"); // Remove colorMode from local storage
  setAuthToken(false); // Remove auth header for future requests
  dispatch(setCurrentUser({})); // Set current user to empty object {} which will set isAuthenticated to false
};

// slice definition
export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser: (state, action) => {
      state.isAuthenticated = !isEmpty(action.payload);
      state.user = action.payload;
      state.errors = {}
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.fulfilled, (history) => {
        history.push("/login"); // redirect to login after register
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        const { token } = action.payload; // Set token to localStorage
        localStorage.setItem("jwtToken", token);

        setAuthToken(token); // Set token to Auth header
        const decoded = jwtDecode(token);// Decode token to get user data
        
        // Set current user
        state.isAuthenticated = !isEmpty(action.payload); 
        state.user = decoded;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.errors = action.payload; // handle bad request or error
      })
  }
})

export const { setCurrentUser, setUserLoading } = authSlice.actions;

export default authSlice.reducer;

